import { StyleSheet } from "../StyleSheet";
import { Button, Typography } from "antd";
import { useSelector } from "react-redux";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { getAlertConfirmationData } from "../stores/slices/alertConfirmationSlice";
const { Text } = Typography;


const AlertConfirmModal = () => {
    const {
        show, onPressBtnPrimary, onPressBtnSecondary, title, message, subText, subMessage,
        btnPrimaryText, btnSecondaryText
    } = useSelector(getAlertConfirmationData);

    return ((show) ? (
        <>
            {
                <div style={styles.mainContainer}>
                    <div style={styles.cardContainer}>
                        <div style={styles.headerContainer}>
                            <ExclamationCircleOutlined style={styles.iconStyle} />
                        </div>
                        <div style={styles.bodyContainer}>
                            <h2 style={styles.titleColor}>{title ? title : "¡Estimado usuario!"}</h2>
                            <Text style={{ margin: 5 }}>
                                {message}
                                {
                                    subText ?
                                        <Text style={{ fontSize: 16, fontWeight: 500 }}>&nbsp;{subText}</Text>
                                        : null
                                }
                                {
                                    subMessage ?
                                        <Text>&nbsp;{subMessage}</Text>
                                        : null
                                }
                            </Text>
                        </div>
                    </div>
                    {
                        onPressBtnPrimary && onPressBtnSecondary ?
                            <div style={styles.buttonsContainer}>
                                <Button style={styles.buttonStyle} onClick={() => onPressBtnPrimary()}>{btnPrimaryText ?? "Aceptar"}</Button>
                                <Button style={styles.buttonStyle} onClick={() => onPressBtnSecondary()}>{btnSecondaryText ?? "Cancelar"}</Button>
                            </div>
                            : null
                    }
                </div>
            }
        </>
    ) : (
        null
    ));
};

//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    mainContainer: {
        position: "absolute",
        display: "flex",
        width: "100%",
        height: "100%",
        zIndex: 100,
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgb(0 0 0 / 60%)",
    },
    cardContainer: {
        width: 400,
        borderRadius: "15px",
    },
    headerContainer: {
        display: "flex",
        width: "100%",
        height: 150,
        borderRadius: "15px 15px 0px 0px",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#FFBA00",
    },
    iconStyle: {
        fontSize: 80,
        color: "#ffffff",
    },
    bodyContainer: {
        display: "flex",
        flexDirection: "column",
        padding: "40px 20px 40px 20px",
        borderRadius: "0px 0px 15px 15px",
        alignItems: "center",
        textAlign: "center",
        justifyContent: "center",
        backgroundColor: "#ffffff",
    },
    buttonsContainer: {
        display: "flex",
        width: 450,
        padding: "40px 0px 40px 0px",
        alignItems: "center",
        justifyContent: "space-evenly",
    },
    buttonStyle: {
        height: 40,
        fontSize: 18,
        fontWeight: 600,
        padding: "0px 40px 0px 40px",
        borderRadius: 20,
        border: "none",
        color: "#ffffff",
        backgroundColor: "#0055c2",
    },
    titleColor: {
        margin: 0,
        marginBottom: 20,
        color: "#FFBA00",
    },
});
//-------------------------------------------------------------------------------------------------- Exports
export default AlertConfirmModal;
